import { NON_BRAND_SEARCH_PERF_PATH } from 'src/utils/month-range-filters';

// Routes on which the header's 3rd filter bar (devices, search terms, platforms, clusters) is hidden.
export const ROUTES_WITHOUT_FILTER_BAR: string[] = [
  "/brand/brand-shield/campaigns",
  "/brand/brand-shield/brand-infringement",
  "/brand/brand-shield/bid-strat-testing",
  "/competitors/leaderboard/market-leaders",
  "/competitors/conquest-mode",
  "/competitors/leaderboard/competitors-selection",
  "/competitors/leaderboard/tracked-competitors",
  "/404",
  "/brand/visibility/competitors",
  "/brand/search-performance/conversions",
  "/brand/visibility/search-terms",
  "/admin/sso/list",
  "/admin/cockpit",
  "/admin/sso",
  "/account",
  "/non-brand/visibility",
  "/",
  "/workspaces",
  "/brand/visibility/local",
  "/brand/visibility/overview",
  "/brand/brand-shield/keywords/exact",
  "/brand/brand-shield/keywords/other",
  "/brand-overview",
  "/admin/features/live-bidding/ad-group-based",
  "/brand-wayback",
  "/admin/users",
  "/admin/users/add",
  "/brand/campaign-leaks",
  "/brand/campaign-leaks/leaked-search-terms",
  "/brand/campaign-leaks/account-performance",
  "/brand/search-performance/cluster-manager",
  "/non-brand/search-performance/cluster-manager",
  "/brand/brand-shield/scraping",
  "/brand/brand-shield/ko-bidding/target-impression-share",
  "/brand/brand-shield/ko-bidding/tcpa",
  "/brand/brand-shield/ko-bidding/troas",
  "/brand/brand-shield/ko-bidding/max-cpc",
  "/brand/brand-shield/active-mode",
  "/brand/brand-shield/ko-bidding-auto",
];

// Routes whose secondary header (title + page tabs) follows the Signal 2026 Figma spec (off-white
// bar, 18px title, 14px tabs). Opt-in: the other pages keep the current header until they are aligned.
export const ROUTES_WITH_REDESIGNED_HEADER: string[] = [
  "/brand/brand-shield/brand-infringement",
];

export const usesRedesignedHeader = (pathname: string): boolean => ROUTES_WITH_REDESIGNED_HEADER.includes(pathname);

// Routes on which the clusters (tags) pill is offered.
export const ROUTES_WITH_TAGS: string[] = [
  "/brand/search-performance/explore",
  "/brand/search-performance/traffic",
  "/brand/search-performance/cluster-manager",
  "/non-brand/search-performance/cluster-manager",
  "/non-brand/search-performance",
];

export const isNonBrandSearchPerf = (pathname: string): boolean => pathname === NON_BRAND_SEARCH_PERF_PATH;

// Platforms need a real choice, Non Brand Search Performance included. Clusters need existing clusters, except on
// Non Brand Search Performance which always shows its clusters pill (maquette).
export const showPlatformsPill = (loadedPlatformCount: number): boolean => loadedPlatformCount >= 2;

/**
 * Options of the Platforms pill: on Non Brand Search Performance, the platforms of the Non Brand data (none until
 * loaded), since the workspace list comes from Brand data; the workspace list elsewhere.
 */
export const platformsPillOptions = (
  pathname: string,
  workspacePlatforms: string[],
  nonBrandPlatforms: string[] | undefined
): string[] => (isNonBrandSearchPerf(pathname) ? nonBrandPlatforms ?? [] : workspacePlatforms);

export const showClustersPill = (pathname: string, loadedTagCount: number): boolean =>
  isNonBrandSearchPerf(pathname) || loadedTagCount > 0;
